import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const listBoxHeight = css`
  max-height: 22.4rem;
`;
export const autocompleteClasses = {
  listbox: cn('p-8', listBoxHeight),
};

export const autocompleteStyles = css`
  .MuiInputBase-root {
    padding-inline-end: 1.2rem !important;
  }
`;
